import Vue from 'vue'
import App from './App'
//element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 路由
import router from './routes'

// 滚动条组件
import Vuescroll from 'vuescroll'
// 自定义指令
import 'js/directive/directive'

import svgIcon from 'vue-svg-icon/Icon.vue'

import { Popup } from 'vant';
import 'vant/lib/popup/style';

// 国际化管理
import i18n from './locale'

Vue.component('svgIcon', svgIcon)
Vue.use(ElementUI)
Vue.use(Vuescroll)

Vue.use(Popup)

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
